import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SelectorAppEnvComponent } from '../../../shared/components/selector-app-env/selector-app-env.component';

@Component({
  selector: 'app-select-application-env-dialog',
  templateUrl: './select-application-env-dialog.component.html',
  styleUrls: ['./select-application-env-dialog.component.scss'],

  standalone: true,
  imports: [SelectorAppEnvComponent],
})
export class SelectApplicationEnvDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SelectApplicationEnvDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { lastRoute: string }
  ) {}

  ngOnInit(): void {}

  close(event: boolean): void {
    if (event) {
      this.dialogRef.close();
    }
  }
}
